import React from "react";
import {
  useHistory
} from "react-router-dom";
import ModelViewer from "../../core/ModelViewer/ModelViewer";
import ModelSelection from "./ModelSelection/ModelSelection";
import InfoPopup from "./ModelInfoPopup/ModelInfoPopup";

import { getModelById } from '../../Models'

import styles from "./Zonic.module.css";
import InstrcutionOverlay from "../../core/InstructionOverlay/InstructionOverlay";


export default function Zonic(props: {id?:string;}) {

  const {id} = props;

  const history = useHistory();

  const viewer: any = React.useRef();

  const useInit = id ? parseInt(id) : 1;

  const initModel = getModelById(useInit);
  
  const [currentModel, setCurrentModel] = React.useState(initModel);
  const [opacity, setOpacity] = React.useState(0);


  const appSettings = JSON.parse(sessionStorage.getItem('zonic-app-settings')!) || {};
  const { zonicInstruction } = appSettings;
  const [showInstruction, setShowInstruction] = React.useState(!zonicInstruction);
  React.useEffect(() => {
    if(showInstruction){
      document.querySelector('body')?.classList.add('instruction');
    }else{
      document.querySelector('body')?.classList.remove('instruction');
    }
  },[showInstruction])

  const onLoadCallback = () => {

    if(currentModel?.animationName && currentModel?.animatioDuration){
      viewer.current.playAnimationUntil(currentModel.animationName, currentModel.animatioDuration);
    }
    setOpacity(1);
  };
  
  const selected3DModel = (element: any) =>{
    if(element.id === currentModel?.id) return;
    history.push(`/zonic/${element.id}`);
    if(currentModel?.animationName && currentModel?.animatioDurationEnd){
      viewer.current.playAnimationUntil(currentModel.animationName, currentModel.animatioDurationEnd);
    }
    const millis = currentModel?.animatioDurationEnd || 0;
    setOpacity(0);
    setTimeout(() => {
      setCurrentModel(element);
    }, millis);
  }

  
  const src = currentModel?.url || "";
  return (
    <div className={styles.Home}>
      <div className={styles.Content}>
        <div className={'instruction-info-field'} style={{width: '100%', height: '100%'}}>
          <div className={'instruction-info-back center'} style={{
            backgroundColor: 'transparent',
            // marginTop: '-15px',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            }}>
            <p className={'center'} style={{margin: 0}}>
              <br />
              <br />
              <span className={'flex'} style={{textAlign:'center', textTransform:'uppercase', fontWeight: 'bold'}}>AR-Modus</span>
              <span className={'flex'}><img alt="" className={'instruction-icon'} src="/assets/images/instruction/touch_app_white_24dp.svg" /> verschieben </span>
              <span className={'flex'}><img alt="" className={'instruction-icon'} src="/assets/images/instruction/double_finger_turn_app_white_24dp.svg" /> drehen</span>
              <span className={'flex'}><img alt="" className={'instruction-icon'} src="/assets/images/instruction/zoom_white_24dp.svg" /> skalieren </span>
              <br />
              <br />
              <br />
              <span className={'flex'} style={{textAlign:'center', textTransform:'uppercase', fontWeight: 'bold'}}>3D-Modus</span>
              <span className={'flex'}><img alt="" className={'instruction-icon'} src="/assets/images/instruction/touch_app_white_24dp.svg" /> drehen </span>
              <span className={'flex'}><img alt="" className={'instruction-icon'} src="/assets/images/instruction/zoom_white_24dp.svg" /> skalieren </span>
              <br />
              <br />
              <br />
              <br />
              <br />
            </p>
            {/* <p className={'center'} style={{margin: 0 }}>
            </p> */}
          </div>
          <ModelViewer opacity={opacity} ar noMove ref={viewer} src={src} usdz={currentModel?.usdz} onLoad={onLoadCallback}/>
        </div>
      </div>
      <div className={styles.Info}>
          <InfoPopup model={currentModel}/>
      </div>
      <div className={styles.BottomBar}>
        <ModelSelection initialElement={initModel} onSelect={(e) => {selected3DModel(e)}} />
      </div>
      <div onClick={() => {
        setShowInstruction(false);
        sessionStorage.setItem('zonic-app-settings', JSON.stringify({
          ...appSettings,
          zonicInstruction: true
        }))
      }}>
        {showInstruction ? <InstrcutionOverlay  /> : null}
      </div>
      
    </div>
  );
}